import { Message } from 'element-ui';

export function calIndex(frontIndex, laterIndex, index, length) {
    if (laterIndex < frontIndex) {
        return -1;
    }
    const errorIndex =
        index + frontIndex > length - 1 || index + laterIndex < 0;

    if (errorIndex) {
        return -1;
    }
    let resFrontIndex = null;
    let resLaterIndex = null;

    resFrontIndex = index + frontIndex < 0 ? 0 : index + frontIndex;
    resLaterIndex =
        index + laterIndex > length - 1 ? length - 1 : index + laterIndex;
    return {
        resFrontIndex,
        resLaterIndex
    };
}

export function calSumIndex(fyArr) {
    let res = -1;

    fyArr &&
        fyArr.map((item, index) => {
            let month = Number(item.headerName.split('-')[1]);

            if (month === 6 && res === -1) {
                res = index + 1;
            }
        });
    return res;
}

/**
 *
 * @param {年月数组 例如： [{headerName: "2019-12", field: "month9"}]} fyArr
 * @param {每个月份值的数组} dataArr
 */
export function calFYData(fyArr, dataArr) {
    let res = {
        sumDataOne: 0,
        sumDataTwo: 0
    };
    let tempDataArr = JSON.parse(JSON.stringify(dataArr));
    let tempFyArr = JSON.parse(JSON.stringify(fyArr));
    let firstFYIndex = calSumIndex(tempFyArr);
    let firstFYArr = tempDataArr && tempDataArr.splice(0, firstFYIndex);

    res.sumDataOne = firstFYArr.reduce(function(total, value) {
        const temp = Number(value) || 0;

        return total + temp;
    }, 0);
    tempFyArr && tempFyArr.splice(0, firstFYIndex);
    let secondFYIndex = calSumIndex(tempFyArr);
    let secondFYArr = [];

    if (secondFYIndex === -1) {
        secondFYArr = tempDataArr;
    } else {
        secondFYArr = tempDataArr && tempDataArr.splice(0, secondFYIndex);
    }
    res.sumDataTwo = secondFYArr.reduce(function(total, value) {
        const temp = Number(value) || 0;

        return total + temp;
    }, 0);
    return res;
}

export function getYM() {
    let date = new Date();
    let res = date.getFullYear() + '-' + date.getMonth();

    return res;
}

export function compareSosMonth(dateBase, dateToCompare) {
    let res;
    let dateBaseArr = dateBase > '' ? dateBase.split('-') : [];
    let dateToCompareArr = dateToCompare > '' ? dateToCompare.split('-') : [];

    if (dateBaseArr.length > 0 && dateToCompareArr.length > 0) {
        let dateBaseYear = Number(dateBaseArr[0]) || 0;
        let dateToCompareYear = Number(dateToCompareArr[0]) || 0;
        let dateBaseMonth = Number(dateBaseArr[1]) || 0;
        let dateToCompareMonth = Number(dateToCompareArr[1]) || 0;

        if (dateBaseYear > dateToCompareYear) {
            res = false;
        } else {
            res = dateBaseMonth < dateToCompareMonth ? res = true : false;
        }
    } else {
        res = -1;
    }
    return res;
}

export function compareDateMoveMonth(
    dateBase, //SOS 01-2020
    dateToCompare, // 11-2019
    moveMonth, // 1
    action // equal
) {
    let res;

    let dateBaseArr = dateBase > '' ? dateBase.split('-') : []; //sos
    let dateToCompareArr = dateToCompare > '' ? dateToCompare.split('-') : [];

    if (dateBaseArr.length < 2 || dateToCompareArr.length < 2) {
        return -1;
    }
    let yearCompare = dateBaseArr[0] - dateToCompareArr[0]; //1
    let monthMovedData = Number(dateToCompareArr[1]) + moveMonth; //

    switch (action && action.toString()) {
        case 'equal':
             if (monthMovedData >= 12) {

                let leftMonth = monthMovedData % 12;

                leftMonth === 0 ? leftMonth = 1 : null;

                yearCompare === 1 && leftMonth === Number(dateBaseArr[1]) ?
                    res = true :
                    res = false;
            } else {
                yearCompare === 0 && monthMovedData === Number(dateBaseArr[1]) ?
                    res = true :
                    res = false;
            }
            if(Number(dateToCompareArr[1])===11 && yearCompare===1)
			{
				res = false;
			}
            break;
        case 'compare':
            if (monthMovedData > 12) {
                let leftMonth = monthMovedData % 12;

                leftMonth === 0 ? leftMonth = 1 : null;

                yearCompare === 1 && leftMonth > dateBaseArr[1] ||
                yearCompare < 1 ?
                    res = true :
                    res = false;
                if (!res) {
                    yearCompare > 1 &&
                    monthMovedData / 12 >= 2 &&
                    leftMonth > dateBaseArr[1] ?
                        res = true :
                        true;
                }
            } else if (monthMovedData < 0) {
                let leftMonth = 12 + monthMovedData;

                yearCompare === -1 && leftMonth > dateBaseArr[1] ?
                    res = true :
                    res = false;
                if (!res) {
                    leftMonth < 0 ? leftMonth += 12 : null;
                    yearCompare < -1 &&
                    (monthMovedData > -12 || leftMonth > dateBaseArr[1]) ?
                        res = true :
                        res = false;
                }
            } else {
                yearCompare === 0 && monthMovedData > dateBaseArr[1] ||
                yearCompare < 0 ?
                    res = true :
                    res = false;
            }
            break;
        default:
            res = -1;
    }
    return res;
}



// WEBPACK FOOTER //
// ./src/utils/common.js